/**
 * Top-nav OTC Execution Services — single link, no dropdown.
 */
export const OTC_FORM_PATH = "/otc";
export const OTC_NAV_LABEL = "OTC Execution Services";

export function isOtcNavActive(pathname) {
  const path = String(pathname || "").split("?")[0];
  return (
    path === "/otc" ||
    path.startsWith("/otc/") ||
    path === "/otc-desk" ||
    path === "/otc_desk" ||
    path === "/otc-service" ||
    path === "/otc_service"
  );
}
